module.exports = __webpack_public_path__ + "static/media/level-2.46ceb289.svg";